import { Navigate } from "react-router-dom";
import Fallback from "components/Fallback";
import useFetchDefaultEntity from "services/hooks/useFetchDefaultEntity";
import { useKeycloak } from "@react-keycloak/web";

const RedirectSignedUser = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const isLoggedIn = !!keycloak?.authenticated;

  const { isSuccess, data, isFetching } = useFetchDefaultEntity(isLoggedIn);

  if (!initialized) return <Fallback />;

  if (!isLoggedIn) {
    keycloak.login({
      redirectUri: `${window.location.origin}/oidc_callback`,
      scope: "openid",
    });
    return null;
  }

  if (isFetching) return <Fallback />;

  if (isSuccess) {
    if (data?.id) return <Navigate to={`/dashboard?entityId=${data.id}`} />;
    return <Navigate to={`/setup/create-entity`} />;
  }

  return <Fallback />;
};

export default RedirectSignedUser;
